import {createSlice, PayloadAction} from '@reduxjs/toolkit'

interface UserState {
    needToUpdateData: string[]
}

const initialState: UserState = {
    needToUpdateData: []
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setNeedToUpdateData: (state: UserState, action: PayloadAction<string[]>) => {
            state.needToUpdateData = action.payload
        }
    }
})

export const {
    setNeedToUpdateData
} = userSlice.actions

export default userSlice.reducer
